import { render, staticRenderFns } from "./DialogMixin.vue?vue&type=template&id=35e6a45a"
import script from "./DialogMixin.vue?vue&type=script&lang=ts"
export * from "./DialogMixin.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports